import { render, staticRenderFns } from "./InvitationManage.vue?vue&type=template&id=73686ec9&scoped=true&"
import script from "./InvitationManage.vue?vue&type=script&lang=js&"
export * from "./InvitationManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73686ec9",
  null
  
)

export default component.exports